import TWEEN from '@tweenjs/tween.js'
import Img from './Img'
import Shape from './Shape'
import { SHAPES_PORTRAIT } from '../shapesPortrait'
import { SHAPES_LANDSCAPE } from '../shapesLandscape'
import Mask from './Mask'

const { Cubic } = TWEEN.Easing

export function getElementsStartLandscape() {
	return [
		new Mask(new Shape(SHAPES_LANDSCAPE.maskStart), [
			new Img({
				node: document.querySelector(`.js-image-start_background`),
				keyframes: {
					inBackward: {
						duration: 1100,
						left: () => [-1, 0],
						easing: Cubic.Out,
					},
					outForward: {
						duration: 1250,
						delay: 250,
						left: () => [0, -0.5],
						easing: Cubic.In,
					},
				},
			}),
		]),
		new Shape(SHAPES_LANDSCAPE.stripeIntro),
		new Mask(new Shape(SHAPES_LANDSCAPE.maskStart2), [
			new Img({
				node: document.querySelector(`.js-image-logo`),
				keyframes: {
					inForward: {
						duration: 2000,
						alpha: [0.95, 0],
					},
					outBackward: {
						duration: 0,
						alpha: [0, 0],
					},
				},
			}),
			new Img({
				node: document.querySelector(`.js-image-start_foreground`),
				align: ['right', 'top'],
				sizing: 'height',
				keyframes: {
					inForward: {
						duration: 1000,
						left: () => [0, -0.1],
						easing: Cubic.Out,
					},
					inBackward: {
						duration: 1000,
						left: () => [-1, -0.1],
						easing: Cubic.Out,
					},
					outForward: {
						duration: 1250,
						delay: 250,
						left: () => [-0.1, -0.5],
						easing: Cubic.In,
					},
				},
			}),
		]),
	]
}

export function getElementsStartPortrait() {
	return [
		new Mask(new Shape(SHAPES_PORTRAIT.start1), [
			new Img({
				node: document.querySelector(`.js-image-start_background`),
				keyframes: {
					inBackward: {
						duration: 1250,
						top: () => [0.25, 0],
						easing: Cubic.Out,
					},
					outForward: {
						duration: 750,
						delay: 250,
						top: () => [0, 0.25],
						easing: Cubic.In,
					},
				},
			}),
			new Img({
				node: document.querySelector(`.js-image-logo`),
				sizing: 'width',
				scale: [2.5, 2.5],
				keyframes: {
					inForward: {
						duration: 500,
						alpha: [1, 0],
					},
				},
			}),
			new Img({
				node: document.querySelector(`.js-image-start_foreground`),
				sizing: 'height',
				align: ['right', 'center'],
				keyframes: {
					inForward: {
						duration: 1000,
						delay: 250,
						top: () => [0, 0.15],
						easing: Cubic.Out,
					},
					inBackward: {
						duration: 1250,
						top: () => [0.25, 0.15],
						easing: Cubic.Out,
					},
					outForward: {
						duration: 750,
						delay: 250,
						top: () => [0.15, 0.25],
						easing: Cubic.In,
					},
				},
			}),
		]),
		new Shape(SHAPES_PORTRAIT.start2),
	]
}